import { LoadablePaint } from '@confluence/loadable';

export const ContentTypesHeaderLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ContentTypesHeader" */ './ContentTypesHeader.tsx'))
			.ContentTypesHeader,
});
